import React from "react";
import Select from "react-select";
import { QRCodeSVG } from "qrcode.react";
import PopUpComponent from "../../components/PopUp/PopUpComponent";
import { useInOutKendaraan } from "./useInOutKendaraan";
import AntiCapture from "react-anticapture";
import "./InOutKendaraan.css";
import { hasRole } from "../../util/utilFunction";

export default function InOutKendaraan() {
  const {
    dataUser,
    canShowQr,
    canScan,
    subMenu,
    setSubMenu,
    dataQr,
    sisaDetik,
    qrHidden,
    type,
    setType,
    listKendaraan,
    listCustomer,
    listRit,
    vehiclePick,
    setVehiclePick,
    customerPick,
    setCustomerPick,
    ritPick,
    setRitPick,
    keterangan,
    handleKeterangan,
    scanning,
    startScan,
    stopScan,
    popup,
    closePopup,
    tanggal,
    setTanggal,
    geserHari,
    hariIni,
    rowsMonitoring,
    ringkasan,
    formatMenit,
    formatJam,
    formatWaktu,
    detailRow,
    setDetailRow,
    exportExcel,
  } = useInOutKendaraan();

  const classTab = (nama) =>
    subMenu === nama
      ? "sub-menu-kendaraan border-active-kendaraan"
      : "sub-menu-kendaraan";

  return (
    <div className="container_dashboard">
      {popup.open ? (
        <PopUpComponent small>
          <div className={`popup-kendaraan popup-kendaraan-${popup.type}`}>
            {popup.title ? (
              <p className="popup-kendaraan-title">{popup.title}</p>
            ) : (
              ""
            )}
            <p className="popup-kendaraan-message">{popup.message}</p>
            <button className="popup-kendaraan-button" onClick={closePopup}>
              OK
            </button>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}

      {scanning ? (
        <PopUpComponent small>
          <div className="popup-scan-kendaraan">
            <p className="popup-kendaraan-title">
              {type === "IN" ? "Scan Masuk" : "Scan Keluar"}
            </p>
            <p className="popup-scan-info">
              {vehiclePick?.label}
              {type === "OUT" && customerPick.length > 0
                ? ` → ${customerPick.map((c) => c.label).join(" + ")}`
                : ""}
              {type === "OUT" && ritPick ? ` (Rit ${ritPick.value})` : ""}
            </p>
            <div id="reader" className="reader-kendaraan" />
            <button className="button-batal-kendaraan" onClick={stopScan}>
              Batal
            </button>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}

      {detailRow ? (
        <PopUpComponent
          small
          style={{ marginTop: "calc(100vh - 96vh - 20px)" }}
        >
          <div className="popup-detail-kendaraan">
            <p className="popup-kendaraan-title">Detail {detailRow.nopol}</p>

            <div className="grid-detail-kendaraan">
              {[
                ["Nopol", detailRow.nopol],
                ["Customer", detailRow.customer],
                ["Tanggal", detailRow.tanggal],
                ["Rit", detailRow.rit],
                ["Waktu Keluar", formatWaktu(detailRow.timeOut)],
                ["Waktu Masuk", formatWaktu(detailRow.timeIn)],
                ["Batas Kembali", formatWaktu(detailRow.batasKembali)],
                ["Durasi Standar", formatMenit(detailRow.durasiStandarMenit)],
                ["Toleransi", `${detailRow.toleransiMenit} menit`],
                ["Durasi Aktual", formatMenit(detailRow.durasiAktualMenit)],
                ["Status", detailRow.statusRow.label],
                ["Terlambat", `${detailRow.terlambatMenit || 0} menit`],
                ["Security Keluar", detailRow.securityOut || "-"],
                ["Security Masuk", detailRow.securityIn || "-"],
                ["User Keluar", detailRow.userOut || "-"],
                ["User Masuk", detailRow.userIn || "-"],
                ["Keterangan", detailRow.keterangan || "-"],
              ].map(([label, value]) => (
                <div className="item-detail-kendaraan" key={label}>
                  <span className="label-detail-kendaraan">{label}</span>
                  <span className="value-detail-kendaraan">{value}</span>
                </div>
              ))}
            </div>

            <button
              className="popup-kendaraan-button"
              onClick={() => setDetailRow(null)}
            >
              Tutup
            </button>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}

      <div className="wrapper-sub-menu-kendaraan">
        {canShowQr ? (
          <p className={classTab("QR")} onClick={() => setSubMenu("QR")}>
            Show QR
          </p>
        ) : (
          ""
        )}
        {canScan ? (
          <p className={classTab("Scan")} onClick={() => setSubMenu("Scan")}>
            Scan
          </p>
        ) : (
          ""
        )}
        <p
          className={classTab("Monitoring")}
          onClick={() => setSubMenu("Monitoring")}
        >
          Monitoring
        </p>
      </div>

      {subMenu === "QR" ? (
        <AntiCapture
          screenshotPrevent={true}
          clipboardPrevent={true}
          devtoolsPrevent={true}
          userSelect={false}
        >
          <div className="wrapper-qr-kendaraan qr-protected">
            <p className="title-qr-kendaraan">QR Scan Gerbang</p>
            {dataQr?.token ? (
              <>
                <div className="qr-box-protected">
                  {qrHidden ? (
                    <div
                      className="qr-cover"
                      style={{ width: 280, height: 280 }}
                    >
                      QR disembunyikan
                    </div>
                  ) : (
                    <QRCodeSVG value={dataQr.token} size={280} />
                  )}
                  {/* watermark pengganggu untuk foto layar */}
                  <div className="qr-watermark">
                    {dataUser?.name || dataUser?.username || "SECURITY"}
                  </div>
                </div>
                {hasRole(dataUser, "super_user") ? (
                  <p>Berlaku: {sisaDetik} detik</p>
                ) : (
                  ""
                )}
              </>
            ) : dataQr?.message ? (
              <p>{dataQr.message}</p>
            ) : (
              <p>Memuat QR...</p>
            )}
          </div>
        </AntiCapture>
      ) : (
        ""
      )}

      {subMenu === "Scan" ? (
        <div className="wrapper-qr-kendaraan">
          <p className="title-qr-kendaraan">Scan Kendaraan</p>

          <div className="wrapper-pilih-type-kendaraan">
            <button
              className={
                type === "OUT"
                  ? "button-type-kendaraan active"
                  : "button-type-kendaraan"
              }
              onClick={() => setType("OUT")}
            >
              Keluar
            </button>
            <button
              className={
                type === "IN"
                  ? "button-type-kendaraan active"
                  : "button-type-kendaraan"
              }
              onClick={() => setType("IN")}
            >
              Masuk
            </button>
          </div>

          <div className="wrapper-select-kendaraan">
            <p style={{ fontWeight: 600 }}>Kendaraan</p>
            <Select
              placeholder="Pilih Kendaraan"
              options={listKendaraan}
              value={vehiclePick}
              onChange={setVehiclePick}
            />
          </div>

          {type === "OUT" ? (
            <>
              <div className="wrapper-select-kendaraan">
                <p style={{ fontWeight: 600 }}>Customer</p>
                <Select
                  placeholder="Pilih Customer (bisa lebih dari satu)"
                  options={listCustomer}
                  value={customerPick}
                  onChange={(v) => setCustomerPick(v || [])}
                  isMulti
                  closeMenuOnSelect={false}
                />
              </div>
              <div className="wrapper-select-kendaraan">
                <p style={{ fontWeight: 600 }}>Rit</p>
                <Select
                  placeholder="Pilih Rit"
                  options={listRit}
                  value={ritPick}
                  onChange={setRitPick}
                />
              </div>
            </>
          ) : (
            <div className="wrapper-select-kendaraan">
              <div className="header-keterangan-kendaraan">
                <p style={{ fontWeight: 600 }}>Keterangan</p>
                <span className="badge-opsional-kendaraan">Opsional</span>
              </div>
              <textarea
                className="textarea-keterangan-kendaraan"
                placeholder="CONTOH: MACET, BAN BOCOR, ANTRI BONGKAR"
                value={keterangan}
                maxLength={200}
                rows={4}
                onChange={(e) => handleKeterangan(e.target.value)}
              />
              <div className="footer-keterangan-kendaraan">
                <span>Isi jika terlambat</span>
                <span>{keterangan.length}/200</span>
              </div>
            </div>
          )}

          <button className="button-scan-kendaraan" onClick={startScan}>
            Mulai Scan
          </button>
        </div>
      ) : (
        ""
      )}

      {subMenu === "Monitoring" ? (
        <div>
          <div className="filter-monitoring-kendaraan">
            <button
              className="button-hari-kendaraan"
              onClick={() => geserHari(-1)}
            >
              ‹
            </button>
            <input
              type="date"
              className="input-tanggal-kendaraan"
              value={tanggal}
              onChange={(e) => e.target.value && setTanggal(e.target.value)}
            />
            <button
              className="button-hari-kendaraan"
              onClick={() => geserHari(1)}
            >
              ›
            </button>
            {tanggal !== hariIni ? (
              <button
                className="button-hari-ini-kendaraan"
                onClick={() => setTanggal(hariIni)}
              >
                Hari Ini
              </button>
            ) : (
              ""
            )}
            <button
              className="button-hari-ini-kendaraan"
              style={{ background: "green" }}
              onClick={exportExcel}
            >
              Export Excel
            </button>
          </div>

          <div className="wrapper-ringkasan-kendaraan">
            <div className="card-ringkasan-kendaraan">
              <p className="angka-ringkasan-kendaraan">{ringkasan.total}</p>
              <p>Total</p>
            </div>
            <div className="card-ringkasan-kendaraan">
              <p className="angka-ringkasan-kendaraan">{ringkasan.tepat}</p>
              <p>Tepat Waktu</p>
            </div>
            <div className="card-ringkasan-kendaraan card-ringkasan-merah">
              <p className="angka-ringkasan-kendaraan">{ringkasan.terlambat}</p>
              <p>Terlambat</p>
            </div>
            <div className="card-ringkasan-kendaraan">
              <p className="angka-ringkasan-kendaraan">{ringkasan.diLuar}</p>
              <p>Di Luar</p>
            </div>
          </div>

          <div className="wrapper-tabel-kendaraan">
            <table className="tabel-kendaraan">
              <thead>
                <tr>
                  <th>No.</th>
                  <th>Nopol</th>
                  <th>Customer</th>
                  <th>Rit</th>
                  <th>Keluar</th>
                  <th>Masuk</th>
                  <th>Durasi</th>
                  <th>Batas</th>
                  <th>Status</th>
                  <th>Keterangan</th>
                </tr>
              </thead>
              <tbody>
                {rowsMonitoring.length === 0 ? (
                  <tr>
                    <td colSpan={10} className="kosong-tabel-kendaraan">
                      Belum ada data
                    </td>
                  </tr>
                ) : (
                  rowsMonitoring.map((row, i) => (
                    <tr
                      key={row._id}
                      className={`baris-klik-kendaraan ${
                        row.statusRow.late ? "baris-terlambat" : ""
                      }`}
                      onClick={() => setDetailRow(row)}
                    >
                      <td>{i + 1}.</td>
                      <td>{row.nopol}</td>
                      <td>{row.customer}</td>
                      <td>{row.rit}</td>
                      <td>{formatJam(row.timeOut)}</td>
                      <td>{formatJam(row.timeIn)}</td>
                      <td>{formatMenit(row.durasiAktualMenit)}</td>
                      <td>
                        {formatMenit(
                          row.durasiStandarMenit + row.toleransiMenit
                        )}
                      </td>
                      <td style={{ fontWeight: 600 }}>{row.statusRow.label}</td>
                      <td>{row.keterangan || "-"}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}
